// =========================================================
// SECTION PROMOTIONS — carousel Splide des vignettes produit.
// Flèches custom dans le header de section (pas les flèches Splide).
// Vignettes : départ aligné conteneur, débordement à droite de l'écran
// (track overflow:visible + section overflow-x:clip, cf. SCSS).
// =========================================================
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.km-promos').forEach((section) => {
        const el = section.querySelector('.km-promos__splide');
        if (!el || el.dataset.kmPromosInitialized) return;
        el.dataset.kmPromosInitialized = '1';

        // Rideau : la section s'épingle quand son BAS atteint le bas du viewport,
        // puis les services glissent par-dessus (comme promos sur le hero). Le top
        // sticky exact = viewport - hauteur réelle, inexprimable en CSS pur → recalé
        // ici (le -4.6875rem du SCSS couvre le cas nominal avant que le JS passe).
        // ⤵️ RIDEAU TEMPORAIREMENT DÉSACTIVÉ (demande Olivier 09/07) — décommenter
        // avec le bloc sticky du SCSS pour réactiver. ⚠️ ne PAS laisser tourner sur
        // position:relative (top décale visuellement la section).
        // const setPinTop = () => {
        //     section.style.top = Math.min(0, window.innerHeight - section.offsetHeight) + 'px';
        // };
        // setPinTop();
        // window.addEventListener('resize', setPinTop);
        // window.addEventListener('load', setPinTop);

        // Largeur de carte CALCULÉE pour montrer exactement N cartes dont la dernière
        // à moitié (3.5 en desktop, 2.5 en tablette, 1.15 en mobile) quelle que soit
        // la largeur d'écran — une fixedWidth statique ne coupe « à 1/2 » qu'à une
        // seule résolution (demande Olivier).
        const GAP = 32;
        const visibleCount = () => window.innerWidth < 768 ? 1.15 : (window.innerWidth < 1200 ? 2.5 : 3.5);
        const cardWidth = () => {
            const track = el.querySelector('.splide__track').clientWidth;
            const n = visibleCount();
            return Math.floor((track - Math.ceil(n - 1) * GAP) / n);
        };

        const splide = new Splide(el, {
            type: 'slide',
            rewind: true, // l'autoplay reboucle au début en fin de piste
            perMove: 1,
            gap: GAP + 'px',
            fixedWidth: cardWidth() + 'px',
            trimSpace: true,
            pagination: false,
            arrows: false, // flèches custom du header
            breakpoints: {
                // mobile : bullets de position à la place des flèches (comme les
                // services — retour Olivier), swipe naturel
                767: {pagination: true},
            },
            // pas d'Autoplay Splide : autoplay maison plus bas (setInterval)
            // ⚠️ Splide passe speed à 0 (transitions instantanées) quand l'OS est en
            // « Réduire les animations » — Olivier veut garder la glisse partout.
            reducedMotion: {speed: 400, rewindSpeed: 400},
        });

        splide.mount();
        el.splide = splide; // debug/vérification (instance accessible depuis la console)

        // Recalcule la largeur au resize (rAF debounce, pas l'event Splide → boucle)
        let raf = null;
        window.addEventListener('resize', () => {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                splide.options = {fixedWidth: cardWidth() + 'px'};
            });
        });
        // Butées + fondu (retours Olivier) :
        // - en FIN de piste : flèche droite grisée (on comprend que c'est fini) et
        //   fondu beige sur la carte coupée à gauche (seule position de repos où ça
        //   arrive, la butée trimSpace n'étant pas alignée sur une carte entière) ;
        // - au DÉBUT : flèche gauche grisée.
        const prev = section.querySelector('.km-promos__arrow--prev');
        const next = section.querySelector('.km-promos__arrow--next');

        const refresh = () => {
            // ⚠️ fin détectée par la POSITION réelle, pas l'index : avec trimSpace le
            // translate est clampé à la butée dès que les dernières cartes remplissent
            // l'écran alors que l'index continue de compter (clics « morts »).
            const Move = splide.Components.Move;
            const atEnd = Math.abs(Move.getPosition() - Move.getLimit(true)) < 2;
            const atStart = Math.abs(Move.getPosition() - Move.getLimit(false)) < 2;
            section.classList.toggle('is-end', atEnd);
            if (prev) prev.toggleAttribute('disabled', atStart);
            if (next) next.toggleAttribute('disabled', atEnd);
        };
        ['mounted', 'moved', 'resized'].forEach((e) => splide.on(e, refresh));
        refresh();

        // Anticipation : dès le DÉBUT du déplacement (event move, destination connue),
        // on pose/retire .is-end → le fondu glisse PENDANT le trajet, pas après
        // l'arrivée (retour Olivier : « arrive tardivement »).
        splide.on('move', (newIndex) => {
            const endIdx = lastReachable();
            section.classList.toggle('is-end', newIndex >= endIdx);
            if (next) next.toggleAttribute('disabled', newIndex >= endIdx);
            if (prev) prev.toggleAttribute('disabled', newIndex === 0);
        });

        // ⚠️ Index RÉELLEMENT atteignable : au-delà, le translate est clampé par
        // trimSpace et l'index dérive (clics « morts » dans les deux sens — vécu).
        // On borne donc la navigation à cet index au lieu d'utiliser go('>'/'<').
        const lastReachable = () => {
            const limit = Math.abs(splide.Components.Move.getLimit(true));
            return Math.max(0, Math.min(splide.length - 1, Math.ceil(limit / (cardWidth() + GAP))));
        };

        // AUTOPLAY MAISON (setInterval — l'Autoplay Splide dérive d'index en butée
        // trimSpace et « colle » à la fin ; en plus son minuteur rAF est bridé en
        // headless, cf. skill) : avance jusqu'à la butée VISUELLE puis REVIENT AU
        // DÉBUT (demande Olivier). Pause au survol, stop définitif à la 1ʳᵉ interaction.
        let userInteracted = false;
        setInterval(() => {
            // :hover interrogé EN DIRECT — un flag mouseenter/mouseleave reste
            // coincé quand la page défile sous un curseur immobile (mouseleave
            // ne part qu'au mouvement de souris) et gèle l'autoplay.
            if (userInteracted || section.matches(':hover') || document.hidden) return;
            const Move = splide.Components.Move;
            const atEnd = Math.abs(Move.getPosition() - Move.getLimit(true)) < 2;
            splide.go(atEnd ? 0 : Math.min(splide.index + 1, lastReachable()));
        }, 4000);

        const stopAutoplay = () => { userInteracted = true; };
        splide.on('drag', stopAutoplay);
        // tap sur une bullet mobile = interaction → stop autoplay aussi
        el.querySelector('.splide__pagination')?.addEventListener('click', stopAutoplay);
        if (prev) prev.addEventListener('click', () => {
            stopAutoplay();
            splide.go(Math.max(0, Math.min(splide.index - 1, lastReachable() - 1)));
        });
        if (next) next.addEventListener('click', () => {
            stopAutoplay();
            splide.go(Math.min(splide.index + 1, lastReachable()));
        });
    });

});
